<template>
    <div class="home">
        <v-container fill-height class="pt-0">
            <h2 class="mb-3">Daily Standup</h2>
            <report-filter :show-operator-filter="false"
                           ref="reportFilter"
                           :show-site-filter="false"
                           :show-responsible-team-filter="false"
                           :report-filter-override="reportFilterOverride"
                           :show-incident-type-filter="false"></report-filter>


            <v-row v-for="row in reportLayouts" :key="row.id">
                <v-col cols="12" :key="chart.chartId" v-for="chart in row.cols" :md="chart.colSpan" xs="12" sm="12">
                    <chart-view :chart-id="chart.chartId"
                                :show-date-range="false"
                                :key="chart.id"
                                :chart-type="chart.chartType"
                                @on-operator-select="onOperatorSelect"
                                @on-severity-select="onSeveritySelect"
                                :report-filter-override="reportFilterOverride"
                                :report-layout-id="chart.reportLayoutId"
                                is-daily-standup
                                @replaced="onReplaced"></chart-view>
                </v-col>
            </v-row>



            <!--<v-row>
                <v-col cols="12">
                    <v-btn outlined
                           rounded
                           @click="isChartSelectorVisible = !isChartSelectorVisible"
                           text>
                        EDIT MODE
                    </v-btn>
                </v-col>
            </v-row>-->


        </v-container>
    </div>
</template>

<script>
    import ChartView from "../../components/charts/ChartView"
    import ReportFilter from "../../components/reports/ReportFilter"
    import ReportLayoutService from "../../services/reportLayoutService"
    import moment from 'moment';

    export default {
        name: 'PostSevDetails',
        data: function () {
            return {
                accessToken: null,
                reportLayouts: [],
                reportFilterOverride: {
                    reportDateType: 1,
                    startDate: moment().subtract(1, "days").format(moment.HTML5_FMT.DATE),
                    startTime: "06:00",
                    endDate: moment().format(moment.HTML5_FMT.DATE),
                    endTime: "06:00",
                    selectedOperatorBrands: [],
                    selectedIncidentTypes: [],
                    selectedResponsibleTeams: [],
                    selectedSites: [],
                    startDateAndTime: null,
                    endDateAndTIme: null,
                    name: ""
                },
                scrollPosition: null
            }
        },
        components: {
            ReportFilter,
            ChartView
        },
        methods: {
            async setup() {
                this.accessToken = this.$auth.getAccessToken();

                //logic to check if date falls on a monday then backdate to friday
                if (moment().weekday() === 1) {
                    this.reportFilterOverride.startDate = moment().subtract(3, "days").format(moment.HTML5_FMT.DATE)
                }

                await this.getReportLayout("DailyStandup");
            },
            async getReportLayout(name) {
                let results = await ReportLayoutService.getReportLayoutsByName(name, false, this.accessToken);

                let reportRows = [];

                results.forEach(function (item) {

                    if (!reportRows[item.row - 1]) {
                        reportRows.push({
                            cols: [
                                {
                                    chartId: item.chartId,
                                    chartType: item.chartType,
                                    reportLayoutId: item.id,
                                    colSpan: item.colSpan
                                }
                            ]
                        });
                    }
                    else {
                        reportRows[item.row - 1].cols.push({
                            chartId: item.chartId,
                            chartType: item.chartType,
                            reportLayoutId: item.id,
                            colSpan: item.colSpan
                        });
                    }

                });

                this.reportLayouts = reportRows;
            },
            getCols(cols) {
                return Math.floor(12 / cols);
            },
            onChartSelectorClose() {
                this.isChartSelectorVisible = false;
            },
            onReplaced() {
                this.reportLayouts = [];
                this.getReportLayout("DailyStandup");
            },
            updateScroll() {
                var header = document.getElementById("myHeader");

                // Get the offset position of the navbar
                var sticky = header?.offsetTop;

                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                } else {
                    header.classList.remove("sticky");
                }
            },
            onOperatorSelect(evt) {
                this.reportFilterOverride.selectedOperatorBrands = [];

                var operatorBrands = this.$refs.reportFilter.getOperatorBrands();

                operatorBrands.forEach(brand => {
                    if (brand.toLowerCase() === evt.toLowerCase()) {
                        this.reportFilterOverride.selectedOperatorBrands.push(brand);
                    }
                });
            },
            onSeveritySelect(evt) {
                this.reportFilterOverride.selectedIncidentTypes = [];
                this.reportFilterOverride.selectedIncidentTypes.push(evt);
            }
        },
        created() {
            this.setup();
            window.addEventListener('scroll', this.updateScroll);
        }
    }
</script>
